/** Domínio canônico para SEO e links gerados pelo app (sem www).
 *  Produção também atende https://www.pleinipouquer.com/ — ver .cursor/docs/feature-seo-indexacao-google.md */
export const CANONICAL_ORIGIN = 'https://pleinipouquer.com';

export function roomShareUrl(roomId) {
    return `${CANONICAL_ORIGIN}/room/${roomId}`;
}
